import { getMessageError } from 'utils/helpers';

import { nvMessaging } from 'services/nvMessaging';

import {
  MessageTemplatesResponse,
  PartnerPreferencesResponse,
  TriggerCodes,
  TriggersResponse,
} from './types';

const getTriggers = async () => {
  try {
    const { data } = await nvMessaging.get<TriggersResponse>(`v1/triggers`);

    return data;
  } catch (e) {
    throw new Error(
      getMessageError(e, 'Unexpected error occurred while retrieving triggers'),
    );
  }
};

const getPartnerPreferences = async (triggerCode?: TriggerCodes) => {
  const params = new URLSearchParams();

  if (triggerCode) {
    params.append('trigger_code', triggerCode);
  }

  try {
    const { data } = await nvMessaging.get<PartnerPreferencesResponse>(
      `v1/partners/preferences`,
      { params },
    );

    return data;
  } catch (e) {
    throw new Error(
      getMessageError(
        e,
        'Unexpected error ocurred while retrieving suggested messages partner preferences',
      ),
    );
  }
};

const getMessageTemplates = async (triggerCode: TriggerCodes) => {
  try {
    const { data } = await nvMessaging.get<MessageTemplatesResponse>(
      `v1/message-templates?trigger_code=${triggerCode}`,
    );

    return data;
  } catch (e) {
    throw new Error(
      getMessageError(
        e,
        'Unexpected error ocurred while retrieving suggested messages templates',
      ),
    );
  }
};

const postPartnerPreferences = async (messageTemplateId: number) => {
  try {
    return await nvMessaging.post('v1/partners/preferences', {
      message_template_ids: [Number(messageTemplateId)],
    });
  } catch (e) {
    throw new Error(
      getMessageError(
        e,
        'Unexpected error ocurred while sending suggested messages partner preferences',
      ),
    );
  }
};

const deleteSuggestedMessage = async (messageId: string) => {
  try {
    await nvMessaging.patch(`v1/messages/${messageId}/cancel`);
  } catch (error) {
    throw new Error(
      getMessageError(
        error,
        'Unexpected error ocurred while deleting suggested message',
      ),
    );
  }
};

export {
  getTriggers,
  getPartnerPreferences,
  getMessageTemplates,
  postPartnerPreferences,
  deleteSuggestedMessage,
};
